// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__tecPx","chartTitle":"Chart_chartTitle__pYhZt"};